<template>
  <el-container direction='vertical'>
    <div class="recharge-center-head">
      <div class="recharge-center-id">会员ID:{{userInfo.mid}}</div>
      <div class="recharge-center-txt">请选择分店</div>
    </div>
    <div class="recharge-center-shop">
      <div class="list flex-r" v-for="(item,i) in shopListData" :key='i'>
        <div class="list-left flex-1">
          <div class="list-left-top">{{item.name}}</div>
          <div class="list-left-bottom">{{item.address}}</div>
        </div>
        <div class="list-right" @click="handleRecharge(item.id)">充值</div>
      </div>
    </div>
  </el-container>
</template>
<script>
import { getUserInfo } from '@/views/mobile/MemberCenter/apis'
import { getShopList } from '@/views/mobile/PublicApp/apis'
export default {
  data () {
    return {
      shopListData: [],
      userInfo: {}
    }
  },
  methods: {
    requestUserInfo () {
      this.loading = this.$toast.loading()
      let data = new FormData()
      data.append('fromUrl', window.location.href)
      getUserInfo(data)
        .then(result => {
          this.loading.hide()
          if (result) {
            this.userInfo = result.data
            if (this.userInfo.mobile === '') {
              let that = this
              this.$dialog({
                closeBtn: false,
                noCancelBtn: true,
                okBtnTxt: '前往修改',
                title: '温馨提示',
                content: '为保证资金安全，请务必如实填写个人信息',
                onOkBtn (event) {
                  this.close()
                  that.$router.push('/public/personal')
                }
              })
            }
            localStorage.setItem('ms_userInfo', JSON.stringify(result.data))
            let userInfo = JSON.parse(localStorage.getItem('ms_userInfo'))
            if (userInfo.ext.shopflag === 'szty') {
              document.title = '陶源酒家'
            } else if (userInfo.ext.shopname !== '') {
              document.title = userInfo.ext.shopname
            } else {
              document.title = '香港富临皇宫'
            }
          }
        }).catch(error => {
          if (error) {
            this.loading.hide()
          }
        })
    },
    requestShopList () {
      this.loading = this.$toast.loading()
      let data = new FormData()
      data.append('fromUrl', window.location.href)
      getShopList(data)
        .then(result => {
          this.loading.hide()
          if (result) {
            this.shopListData = result.data.list
          }
        }).catch(error => {
          if (error) {
            this.loading.hide()
          }
        })
    },
    handleRecharge (id) {
      this.$router.push('/public/recharg?id=' + id)
    }
  },
  mounted () {
    this.requestUserInfo()
    this.requestShopList()
  }
}
</script>
<style lang="less">
.nut-dialog-ok {
  background: linear-gradient(315deg, #fff 0%, #fff 100%);
}
.nut-dialog-ok:active {
  background: inherit;
}
.recharge-center-head {
  font-size: 18px;
  height: 48px;
  line-height: 48px;
  overflow: hidden;
  border-bottom: 2px solid #f00;
  box-sizing: border-box;
  padding: 0 16px;
  color: #666;
  .recharge-center-id {
    float: left;
  }
  .recharge-center-txt {
    float: right;
  }
}
.recharge-center-shop {
  font-size: 15px;
  .list {
    cursor: pointer;
    margin: 16px;
    box-sizing: border-box;
    border: 1px solid #ddd;
    border-radius: 6px;
    overflow: hidden;
    .list-left-top {
      font-size: 20px;
      margin: 16px 0 10px 0;
      color: #666;
      font-weight: 600;
      padding: 0 16px;
      box-sizing: border-box;
    }
    .list-left-bottom {
      margin-bottom: 16px;
      padding: 0 16px;
      box-sizing: border-box;
      color: #999;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 1;
      overflow: hidden;
    }
  }
  .list-right {
    width: 64px;
    line-height: 90px;
    font-size: 17px;
    text-align: center;
    background: linear-gradient(315deg, #ff4f18 0%, #f20000 100%);
    color: #fff;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/mobile/RechargeCenter/index.vue